import { NgModule } from '@angular/core';
import { Pipe, PipeTransform } from '@angular/core';
import { formatInTimeZone } from 'date-fns-tz';

@Pipe({ name: 'tzfmt',standalone:false, })
export class TZFmtPipe implements PipeTransform {
    transform(date: Date | string | null, format: string = 'yyyy-MM-dd', tzname: string = 'UTC'): string {
        if (!date) {
            return ""
        }
        return formatInTimeZone(date, tzname, format);
    }
}

@NgModule({
    declarations: [TZFmtPipe],
    // exports is required so you can access your component/pipe in other modules
    exports: [TZFmtPipe],
})
export class AppTZPipeModule { }
